import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppUnitOfWork, AuthenticationService, AppInformationService, RAFUnitOfWork } from 'src/app/core/core.module';
import 'jquery-slimscroll';
import { BsModalService } from 'ngx-bootstrap/modal';
import { User } from 'src/app/core/data/entities';
import * as moment from 'moment';

declare var jQuery: any;

@Component({
    selector: 'app-navigation',
    templateUrl: 'navigation.template.html',
    standalone: false
})
export class NavigationComponent implements AfterViewInit {
    user: User;
    timeEntries: any;
    monday: any;
    tuesday: any;
    wednesday: any;
    thursday: any;
    friday: any;
    saturday: any;
    sunday: any;
    lastMonday: any;
    lastTuesday: any;
    lastWednesday: any;
    lastThursday: any;
    lastFriday: any;
    lastSaturday: any;
    lastSunday: any;
    startDate: Date;
    endDate: Date;
    lastStartDate: Date;

    constructor(
        private router: Router,
        private uow: AppUnitOfWork,
        private rafuow: RAFUnitOfWork,
        public auth: AuthenticationService,
        private modalService: BsModalService,
        private route: ActivatedRoute,
        public appInfo: AppInformationService
    ) {
        // this.auth.user.subscribe(x => (this.user = x));
        this.auth.user.subscribe((x) => {
            this.user = x;
            // console.log('user', this.user);
        });
    }
    async ngOnInit() {
        const currentDate = new Date();
        this.startDate = moment(currentDate).isoWeekday(0).startOf('day').toDate();
        this.endDate = moment(currentDate).isoWeekday(6).startOf('day').toDate();

        this.timeEntries = await this.rafuow.getTimeEntriesInfosByEmployeeId(this.auth.userValue.employeeId, this.startDate, this.endDate);
        this.timeEntries.forEach((entry) => {
            switch (entry.day) {
                case 'Monday':
                    this.monday = entry.total;
                    break;
                case 'Tuesday':
                    this.tuesday = entry.total;
                    break;
                case 'Wednesday':
                    this.wednesday = entry.total;
                    break;
                case 'Thursday':
                    this.thursday = entry.total;
                    break;
                case 'Friday':
                    this.friday = entry.total;
                    break;
                case 'Saturday':
                    this.saturday = entry.total;
                    break;
                case 'Sunday':
                    this.sunday = entry.total;
                    break;
                default:
                    break;
            }
        });

        this.lastStartDate = moment(currentDate).isoWeekday(0).startOf('day').add(-1, 'week').toDate();
        const lastEndDate = moment(currentDate).isoWeekday(6).startOf('day').add(-1, 'week').toDate();

        const lastTimeEntries = await this.rafuow.getTimeEntriesInfosByEmployeeId(this.auth.userValue.employeeId, this.lastStartDate, lastEndDate);
        lastTimeEntries.forEach((entry) => {
            switch (entry.day) {
                case 'Monday':
                    this.lastMonday = entry.total;
                    break;
                case 'Tuesday':
                    this.lastTuesday = entry.total;
                    break;
                case 'Wednesday':
                    this.lastWednesday = entry.total;
                    break;
                case 'Thursday':
                    this.lastThursday = entry.total;
                    break;
                case 'Friday':
                    this.lastFriday = entry.total;
                    break;
                case 'Saturday':
                    this.lastSaturday = entry.total;
                    break;
                case 'Sunday':
                    this.lastSunday = entry.total;
                    break;
                default:
                    break;
            }
        });

    }

    async ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();

        // const currentUser = null; //await this.auth.getCurrentUser();
        // if (!!currentUser && (currentUser.userName === 'timeCard' || currentUser.userName === 'feedmill')) {
        //     jQuery('body').addClass('mini-navbar');
        // } else {
        //     jQuery('body').removeClass('mini-navbar');
        // }
        jQuery('body').removeClass('mini-navbar');

        if (jQuery('body').hasClass('fixed-sidebar')) {
            jQuery('.sidebar-collapse').slimscroll({
                height: '100%',
            });
        }
    }

    activeRoute(routename: string): boolean {
        // console.log(this.router.url.indexOf(routename) > -1);
        return this.router.url.indexOf(routename) > -1;
    }
}
